import PageWrapper from '../components/basic/PageWrapper';
import LandingSection from '../components/components/HomePage/LandingSection';
import AboutUsSection from '../components/sections/AboutUsSection';
import HomePageHelmet from '../components/components/HomePage/HomePageHelmet';
import ServicesSection from '../components/sections/ServicesSection';
import OurQualities from '../components/components/HomePage/OurQualities';
import OurAchievements from '../components/components/HomePage/OurAchievements';

const HomePage = () => {
	return (
		<>
			<HomePageHelmet />
			<PageWrapper>
				<LandingSection />
				<AboutUsSection />
				<OurQualities />
				<ServicesSection />
				<OurAchievements />
			</PageWrapper>
		</>
	);
};

export default HomePage;
